export const CONSTANTS = {
  PAGE_NAME: {
    DATA_USAGE: 'Data usage details',
  },
  PAGE_DESCRIPTION: {
    'Data usage details':
      'Get details about Australian and International data usage for individual services.',
  },
  SERVICE_USAGE: 'service-usage',
  SERVICE_CONFIG: 'service-configuration',
  APN_TYPES: {
    SHARED: 'shared',
    DEDICATED: 'dedicated',
  },
  BANNER: {
    GENERIC_MESSAGE:
      'This service has exceeded its data allowance. Internet and data speeds may be limited or charges may apply for the remainder of the billing period.',
  },
  PLAN_TYPE: {
    LEGACY: 'legacy',
    STRATEGIC: 'strategic',
  },
  PLAN_TYPE_CODE: {
    EW: 'EW',
    NON_EW: 'NON-EW',
  },
  TRAFFIC_ORIGIN: {
    ROAMING: 'ROAMING',
    DOMESTIC: 'DOMESTIC',
  },
  ALLOWANCE_TYPE: {
    IR_DATA: 'IR DATA',
    STANDARD: 'STANDARD',
    UNSHAPED_BOLT_ON: 'Unshape Bolt-On',
    AUTO_DATA_TOP_UP: 'Auto Data Top-Up Bolt-On',
    IR_DAY_PASS: 'IR DAY PASS',
    IR_TOP_UP: 'IR TOP-UP',
    IR_ADD_ON_PACK: 'IR ADD-ON PACK',
    IR_PAYG_DATA: 'IR PAYG DATA',
    ON_DEMAND_PLAN: {
      PARENT: 'On-Demand Plan active usage',
      HEADING1: 'Active usage',
      HEADING2: 'Usage in the current billing period',
      HEADING3: 'On-Demand Plan active usage breakdown',
      TYPE: {
        ON_DEMAND_AUTO_DATA_TOP_UP: 'ON_DEMAND_AUTO_DATA_TOP_UP',
        ON_DEMAND_DAY_PASS: 'ON_DEMAND_DAY_PASS',
      },
      TEXT: {
        Bill_PERIOD: 'Billing period',
        REMAINING_TEXT: 'In this billing period',
        CURRENT_BILL: 'in current billing period',
      },
    },
  },
  ALLOWANCE_TYPE_DESCRIPTION: {
    ON_DEMAND_AUTO_DATA_TOP_UP: {
      VALUE: 'On Demand Auto Data Top Up',
      DATAHEADER: 'Data top-up data used',
      PRODUCT: {
        TOP_UP: 'Top-up',
        DATA_TOP_UP: 'Data top-up',
      },
    },
    ON_DEMAND_DAY_PASS: {
      VALUE: 'On Demand Day Pass',
      DATAHEADER: 'Day pass data used',
      TIMEHEADER: 'Data top-up hours remaining',
      PRODUCT: {
        DAY_PASS: 'Day pass',
      },
    },
    SUBHEADING: {
      AUSTRALIAN_DATA_USAGE_ALLOWANCE: 'Australian data usage allowance',
      DAY_PASS_ALLOWANCE: 'day pass allowance',
      DATA_TOP_UP_ALLOWANCE: 'data Top-Up allowance',
      INTERNATIONAL_DATA_TOP_UP_ALLOWANCE: 'International data top up allowance',
      INTERNATIONAL_ALLOWANCE: 'International allowance',
    },
  },
  TRAFFIC_TYPE: {
    DATA: 'DATA',
  },
  SERVICE_STATUS: {
    IDLE: 'idle',
    ACTIVE: 'Active',
    PENDING: 'Pending',
    SUBSCRIBE: 'Subscribe',
    UNSUBSCRIBE: 'Unsubscribe',
    SUSPENDED: 'Suspended',
  },
  PRODUCT_DESCRIPTION: {
    AUTO_DATA_TOP_UP_BOLT_ON: 'Auto Data Top-Up Bolt-On',
    UNSHAPED_BOLT_ON: 'Unshape Bolt-On',
  },
  BOLT_ONS_PRODUCT_DESCRIPTION_VALUE: {
    AUTO_DATA_TOP_UP_BOLT_ON: 'Enterprise Wireless data top-up',
    UNSHAPED_BOLT_ON: 'User data top-up',
  },
  IS_SHARED: {
    FALSE: 'FALSE',
    TRUE: 'TRUE',
  },
  ACCELERATOR_DATA_MISSING: {
    HEADER_LABEL: 'Data missing for Accelerator?',
    FOOTER: {
      SECTION1: 'If there is missing data in the above reporting, this could be because:',
      SECTION2:
        'The mobile service has not been used yet. The reporting system takes up to two days for data to display following first usage of the service.',
      SECTION3:
        'The mobile service has not been used for that billing period. Please note that daily data resets on the first day of each billing period, so data starts displaying from the second day of the billing period.',
      SECTION4: 'The mobile service has been connected to Wi-Fi and not our mobile network.',
      SECTION5:
        'The user’s SIM is in a 3G-only device (Accelerator only works on our 4G and 5G networks).',
      SECTION6:
        'Our network and reporting systems are not always fault-free. In rare circumstances data can be missing from the daily report due to a network or system fault.',
    },
  },
  ACCELERATOR: {
    HEADER_LABEL: 'Accelerator',
    DAILY_SPEED_IMPROVEMENT_WITH_ACCELERATOR: 'Daily speed improvement with Accelerator',
    DAILY_SPEED_WITHOUT_ACCELERATOR: 'Daily speed without Accelerator',
    PERCENTAGE_SIGN: '%',
    MBPS: 'Mbps',
    ACCELERATOR_USAGE_DETAIL: 'Offers the maximum network speed available in your area.',
    Graph: {
      VALUESUFFIX: 'Mbps',
      With_Accelerator: 'With Accelerator',
      Without_Accelerator: 'Without Accelerator',
      SUB_HEADER_SECTION: {
        CURRENT_BILLING_PERIOD_IMPROVEMENT: {
          title: 'Current billing period improvement',
          description:
            'The averaged benefit of your default network speed plus the Accelerator network speed over the current billing period.',
        },
        IMPROVEMENT_WITH_ACCELERATOR: {
          title: 'Improvement with Accelerator',
          description:
            'The network speed improvement your service has experienced with the Accelerator add-on.',
        },
        SERVICE_SPEED_WITHOUT_ACCELERATOR: {
          title: 'Service speed without Accelerator',
          description:
            'The default network speed your service would be experiencing without the Accelerator add-on.',
        },
        THIRTY_DAYS_AVERAGE_IMPROVEMENT: {
          title: '30 days average improvement',
          description:
            'The average network speed improvement your service has experienced over the last 30 days with the Accelerator add-on, or since Accelerator has been added (if within the past 30 days).',
        },
      },
    },
    IMPORTANT_SPEED_CALCULATION_DISCLAIMER: 'Important speed calculation disclaimer',
    Four_G_USAGE_ONLY: '4G usage only, 5G usage will be available for compatible devices soon*',
    FOOTER: {
      SECTION1:
        'Your Average Speed Improvement with Accelerator is the average speed you received with Accelerator during active use in a 24 hour cycle.',
      SECTION2:
        'Average Speed without Accelerator is the predicted speed without Accelerator based on daily average speed that we estimate a user on our network in similar radio conditions would have experienced without Accelerator, using national network performance data.',
      SECTION3:
        'The Accelerator reporting portal shows your average received speed during active use measured daily. Note that times of inactivity (such as when your device is in standby on your desk or in your pocket, or when connected to Wi-Fi) are not counted in this measurement. Please note that these measurements are different to speed testing tools like Ookla’s Speed Test app, which measure the limits of your connection over a very short period of time (typically within 30 seconds). As such, results you receive via speed testing tools may differ to the average active use speeds outlined in this portal.',
      SECTION4: `*The results displayed show the speed uplift for the service while the device has been using Telstra's 4G and 5G networks. For 5G enabled devices connected to our 5G network, the device can use aspects of both our 4G and 5G networks simultaneously. Note the above reporting represents uplifts delivered via our 4G network and some aspects of our 5G network, meaning the received performance may be faster or slower than what is shown. We anticipate full 5G speed uplift reporting will be available soon.`,
    },
  },
  FEATURE_NAME: {
    ADD_ONS: 'Add-ons',
  },
  FEATURE_DESCRIPTION: {
    'Add-ons': 'Choose optional extras for this service to suit your business needs.',
  },
  NO_VALUE_DESCRIPTION: {
    'Add-ons': 'No active add-ons',
  },
  API_ERROR: {
    'Add-ons': {
      TITLE: 'Something went wrong',
      MESSAGE: 'Please try again.',
      ICONTYPE: 'lm-picto-warning-56',
      ICONNAME: 'picto-error',
    },
  },
  MOBILITY: 'Mobility',
  REQUEST_MANAGEMENT: 'Request Management',
  INCIDENT_MANAGEMENT: 'Incident Management',
  ORDER_EXPRESS: 'Order Express',
  PLATFORM: 'Platform',
  MOBILE_DATA_USAGE_METER: 'Mobile Data Usage Meter',
  TABS: {
    MOBILE_DATA_USAGE_METER: 'MobileDataUsageMeter',
    REQUEST_MANAGEMENT: 'RequestManagement',
    SERVICE_CONFIGURATION: 'Service configuration',
    SERVICE_USAGE: 'Service usage',
  },
  FAIR_USAGE: {
    shapingEnablementID: 'T22-T1-FP',
    unshapeBoltOnbalanceId: 65003,
    dataTopUpBoltOnbalanceId: 65004,
    SERVICE_USAGE_INFO_TIP:
      'Once the data allowance is exceeded, internet and data speeds may be limited or charges may apply for the remainder of the billing period.',
    INDIVIDUAL_CONTRIBUTION_EXEEDED: 'This service has used its data allowance.',
    FAIRPLAY_CONTRIBUTION_EXEEDED:
      'This service has exceeded its monthly 300GB limit. Its speed has been reduced to a maximum of 1.5 Mbps for the remainder of the billing period. To remove this speed cap, buy a User Data Top-Up.',
    GROUP_ALLOWANCE_EXCEEDED:
      'This service is speed capped because the group allowance has been exceeded. Its speed has been reduced to a maximum of 1.5 Mbps for the remainder of the billing period. To remove this speed cap, buy a User Data Top-Up.',
  },
  REACT_QUERY_KEYS: {
    STRATEGIC_SERVICE_DETAILS: 'strategic-service-details',
    SERVICE_ADDONS: 'service-addons',
    STRATEGIC_SERVICE_USAGE: 'strategic-service-usage',
    STRATEGIC_ACCLERATOR_SERVICE_USAGE: 'strategic-accelerator-service-usage',
    LEGACY_SERVICE_DETAILS: 'legacy-service-details',
    SIM_CONFIG_INFORMATION: 'sim-config-information',
    GET_DIRECTORY_LISTING: 'get-directory-listing',
  },
}
